module.exports = __webpack_public_path__ + "img/collection-memoireRingsColored.44d5884.jpg";